import { Component, OnInit,AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { RouterModule } from '@angular/router';
import  AOS from 'aos';

@Component({
  selector: 'app-in-the-news-cover',
  imports: [CommonModule,RouterModule],
  standalone:true,
  templateUrl: './in-the-news-cover.component.html',
  styleUrl: './in-the-news-cover.component.scss'
})
export class InTheNewsCoverComponent implements OnInit,AfterViewInit{
  constructor(private router: Router) { }
  ngOnInit(): void {
    
  }
    ngAfterViewInit() {
      AOS.init();   
    }
  nav(url: any) {
    this.router.navigateByUrl(url)
  }
}
